import { AuthService } from '../auth.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { AppConstants } from '../shared/app.constants';
var ManagersService = /** @class */ (function () {
    function ManagersService(auth, http, appConstants) {
        this.auth = auth;
        this.http = http;
        this.appConstants = appConstants;
    }
    ManagersService.prototype.getAllManagers = function () {
        var url = environment.apiBase + 'users/managers/';
        var headers = this.auth.getAuthorizationHeaders();
        return this.http.get(url, { headers: headers }).map(function (res) { return res; }).catch(this.appConstants.errorHandler);
    };
    return ManagersService;
}());
export { ManagersService };



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/managers/managers.service.ts.pre-build-optimizer.js